// extracted by mini-css-extract-plugin
module.exports = {"container":"sw-z","disabled":"tw-z"};